import {
  CREATE_BRANCH_PRACTITIONER_FAIL,
  CREATE_BRANCH_PRACTITIONER_REQUEST,
  CREATE_BRANCH_PRACTITIONER_SUCCESS,
  DELETE_BRANCH_PRACTITIONER_FAIL,
  DELETE_BRANCH_PRACTITIONER_REQUEST,
  DELETE_BRANCH_PRACTITIONER_SUCCESS,
  DETAIL_BRANCH_PRACTITIONER_FAIL,
  DETAIL_BRANCH_PRACTITIONER_REQUEST,
  DETAIL_BRANCH_PRACTITIONER_SCHEDULE_FAIL,
  DETAIL_BRANCH_PRACTITIONER_SCHEDULE_REQUEST,
  DETAIL_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS,
  DETAIL_BRANCH_PRACTITIONER_SUCCESS,
  LIST_BRANCH_PRACTITIONER_FAIL,
  LIST_BRANCH_PRACTITIONER_REQUEST,
  LIST_BRANCH_PRACTITIONER_SCHEDULE_FAIL,
  LIST_BRANCH_PRACTITIONER_SCHEDULE_REQUEST,
  LIST_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS,
  LIST_BRANCH_PRACTITIONER_SUCCESS,
  UPDATE_BRANCH_PRACTITIONER_FAIL,
  UPDATE_BRANCH_PRACTITIONER_REQUEST,
  UPDATE_BRANCH_PRACTITIONER_SUCCESS
} from '../../constants/branch-practitioner'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  practitioners: [],
  practitioner: {},
  schedules: [],
  schedule: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listBranchPractitionerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_PRACTITIONER_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_PRACTITIONER_SUCCESS:
      return {
        ...state,
        loading: false,
        practitioners: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PRACTITIONER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case UPDATE_BRANCH_PRACTITIONER_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_BRANCH_PRACTITIONER_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_PRACTITIONER_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case CREATE_BRANCH_PRACTITIONER_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_BRANCH_PRACTITIONER_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_PRACTITIONER_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_BRANCH_PRACTITIONER_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_BRANCH_PRACTITIONER_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_BRANCH_PRACTITIONER_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case DETAIL_BRANCH_PRACTITIONER_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_PRACTITIONER_SUCCESS:
      return { ...state, loadingDetail: false, practitioner: action.payload }
    case DETAIL_BRANCH_PRACTITIONER_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    // practioner schedule
    case LIST_BRANCH_PRACTITIONER_SCHEDULE_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PRACTITIONER_SCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_BRANCH_PRACTITIONER_SCHEDULE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS:
      return { ...state, loadingDetail: false, schedule: action.payload }
    case DETAIL_BRANCH_PRACTITIONER_SCHEDULE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default listBranchPractitionerReducer
